// CardGrid (F-185): the record body. Cards are its only container: as many columns of at least 288 px as the detail
// pane holds, 16 px apart, the cards of a row equal in height — three on a 1280 px laptop, two when the assistant panel
// docks beside the pane (the pane narrows, so the grid reflows; the panel never covers it), one on a phone. A card that
// needs the width spans two columns or the whole row (RecordCard span), and falls back to the row it is given.

import type { ReactNode } from "react";
import { cx } from "../lib/cx";

export interface CardGridProps {
  children?: ReactNode;
  /** Names the grid as a region (optional; a record tab's grid is named by its tab). */
  label?: string | undefined;
  className?: string | undefined;
  id?: string | undefined;
}

export function CardGrid({ children, label, className, id }: CardGridProps) {
  return (
    <div className={cx("mc-cg", className)} id={id} role={label ? "region" : undefined} aria-label={label}>
      {children}
    </div>
  );
}

/** A grid cell for content that is already a card (a lane's own Card), so it can span. */
export function GridCell({ span, children, className }: { span?: 2 | "all" | undefined; children?: ReactNode; className?: string | undefined }) {
  return <div className={cx("mc-cg-c", span === 2 && "mc-cg-2", span === "all" && "mc-cg-all", className)}>{children}</div>;
}
